import { render, staticRenderFns } from "./TimeaxisItem.vue?vue&type=template&id=fe4fb100&scoped=true&"
import script from "./TimeaxisItem.vue?vue&type=script&lang=js&"
export * from "./TimeaxisItem.vue?vue&type=script&lang=js&"
import style0 from "./TimeaxisItem.vue?vue&type=style&index=0&id=fe4fb100&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe4fb100",
  null
  
)

export default component.exports